import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SelectWithSearch from "@/features/shared/components/SelectWithSearch/SelectWithSearch";
import useProjects from "@/features/project/hooks/useProjects";
import { toast } from "react-toastify";
const ProjectSelector = ({ onSelect, initialValue }) => {
    const { projects, handleAddProject } = useProjects(undefined, undefined, true);
    const [selectedProject, setSelectedProject] = useState(initialValue ? { value: initialValue.id ?? 0, label: initialValue.label ?? "" } : { value: 0, label: "" });
    const [localProjects, setLocalProjects] = useState(projects);
    const createdProjectRef = useRef(null);
    useEffect(() => {
        setLocalProjects(projects);
    }, [projects]);
    useEffect(() => {
        if (initialValue) {
            setSelectedProject({ value: initialValue.id ?? 0, label: initialValue.label ?? "" });
        }
    }, [initialValue]);
    const projectOptions = useMemo(() => localProjects.map((p) => ({
        value: p.id ?? 0,
        label: p.label ?? "",
    })), [localProjects]);
    const handleProjectSelect = useCallback((option) => {
        const selected = localProjects.find((p) => p.id === option.value) ||
            (createdProjectRef.current && createdProjectRef.current.id === option.value
                ? createdProjectRef.current
                : undefined);
        setSelectedProject({ value: option.value, label: option.label });
        if (selected) {
            onSelect(selected);
        }
        else {
            onSelect({ id: option.value, label: option.label });
        }
        if (createdProjectRef.current && createdProjectRef.current.id === option.value) {
            createdProjectRef.current = null;
        }
    }, [localProjects, onSelect]);
    const handleCreateProject = useCallback(async (label) => {
        const trimmedLabel = label.trim();
        if (!trimmedLabel) {
            return null;
        }
        const existing = localProjects.find((project) => project.label?.toLowerCase() === trimmedLabel.toLowerCase());
        if (existing) {
            const option = { value: existing.id ?? 0, label: existing.label ?? "" };
            handleProjectSelect(option);
            return option;
        }
        try {
            const newProject = await handleAddProject({
                label: trimmedLabel,
                is_active: true,
            });
            const normalizedProject = {
                ...newProject,
                label: newProject.label ?? trimmedLabel,
            };
            setLocalProjects((prev) => {
                const exists = prev.some((p) => p.id === normalizedProject.id);
                return exists ? prev : [...prev, normalizedProject];
            });
            createdProjectRef.current = normalizedProject;
            toast.success(`Projet "${normalizedProject.label}" ajouté.`);
            return {
                value: normalizedProject.id ?? 0,
                label: normalizedProject.label ?? trimmedLabel,
            };
        }
        catch (error) {
            console.error("Erreur lors de la création du projet :", error);
            toast.error(error?.message ?? "Erreur inattendue lors de la création du projet.");
            return null;
        }
    }, [handleAddProject, handleProjectSelect, localProjects]);
    return (_jsx(SelectWithSearch, { label: "Projet", options: projectOptions, selectedItem: selectedProject, onSelect: handleProjectSelect, allowCreate: true, onCreate: handleCreateProject, getCreateOptionLabel: (value) => `Créer le projet "${value}"` }));
};
export default ProjectSelector;
